import { FileData, SavedTest, StoredFilePayload } from '../types';

const STORAGE_KEY = 'vishwajyot_saved_tests';

const toStoredFile = (file: FileData): StoredFilePayload => ({
  fileName: file.file.name,
  mimeType: file.mimeType,
  base64: file.base64,
});

export const toFileData = (stored: StoredFilePayload): FileData => {
  const blob = dataUrlToBlob(stored.base64);
  const file = new File([blob], stored.fileName, { type: stored.mimeType });
  return {
    file,
    base64: stored.base64,
    mimeType: stored.mimeType,
  };
};

const dataUrlToBlob = (dataUrl: string): Blob => {
  const [header, data] = dataUrl.split(',');
  const mimeMatch = header.match(/:(.*?);/);
  const mime = mimeMatch?.[1] || 'application/octet-stream';
  const binary = atob(data);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
};

export const loadSavedTests = (): SavedTest[] => {
  if (typeof window === 'undefined') return [];
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  try {
    return JSON.parse(raw) as SavedTest[];
  } catch {
    return [];
  }
};

export const saveTest = (input: {
  name: string;
  gradeLevel: string;
  subject: string;
  questionPaper: FileData;
  answerKey: FileData;
}): SavedTest => {
  const test: SavedTest = {
    id: `test-${Date.now()}`,
    name: input.name.trim(),
    gradeLevel: input.gradeLevel,
    subject: input.subject.trim(),
    createdAt: new Date().toISOString(),
    questionPaper: toStoredFile(input.questionPaper),
    answerKey: toStoredFile(input.answerKey),
  };

  const tests = loadSavedTests();
  tests.unshift(test);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tests));
  return test;
};

export const deleteSavedTest = (id: string): void => {
  const tests = loadSavedTests().filter((test) => test.id !== id);
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tests));
};
